import { render, staticRenderFns } from "./DocumentElementViewerMobile.vue?vue&type=template&id=155adc73&lang=pug"
import script from "./DocumentElementViewerMobile.vue?vue&type=script&lang=js"
export * from "./DocumentElementViewerMobile.vue?vue&type=script&lang=js"
import style0 from "./DocumentElementViewerMobile.vue?vue&type=style&index=0&id=155adc73&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports